<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AHbm1t/tc-custom/9780830869367.jpg?1696025826162" alt="This image is the cover for the book What God Thinks When We Fail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What God Thinks When We Fail
      </h1>
      <p class="bookDescription body article font2">
        <p>What does God think of us when we fail? Does he think</p>  You're a loser. There's no hope for you. What a wimp! You're good for nothing!  <p>Or does he think something very different? If you've ever lost a job or a relationship, let your friends down, seen your finances collapse, found your ministry crumbling or failed to meet your own ethical standards, you might wonder if recovery is possible. Perhaps you've wondered if you can ever repair the damage done to others, to yourself and to your relationship with God. Steve Roy has good news for you. He had to face his own failures, but his failures also drove him deep into what God thinks about us and success, especially in Christian ministry. He searched deeply in Scripture and listened carefully to the stories of others. He found that God's view of success is very different from ours. And that a biblically grounded view of success and failure challenges our preconceived notions but leads to hopeful renewal that goes beyond what we often ask or think.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steven C. Roy
      </h2>
      
      <p class="authorDescription body article"><p>Steven C. Roy (Ph.D., systematic theology, Trinity Evangelical Divinity School) is associate professor of pastoral theology at Trinity Evangelical Divinity School in Deerfield, Illinois. He has also taught systematic theology, historical theology and ethics. Prior to coming to Trinity, he was a pastor for twelve years and taught in Cameroon, West Africa. He is author of "God as Omnicompetent Responder? Questions about the Grounds of Eschatological Confidence in Open Theism in<em>Looking to the Future</em>, edited David W. Baker.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22ae2acb